import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  HistoryTips,
  SafetyTips,
  PlaceToGo,
  TransportTips,
  VisaTips,
  WeatherTips,
} from './container';
import { Home, SharedLayout, SingleTour, Error } from './pages';

const App = () => {
  return (
    <BrowserRouter>
      {/* <Navbar /> */}
      {/* <main className="min-h-screen"> */}
      {/* <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/tours/:id" element={<SingleTour />}></Route>

            <Route path="/tips/visa" element={<VisaTips />}></Route>
            <Route path="/tips/transport" element={<TransportTips />}></Route>
            <Route path="/tips/weather" element={<WeatherTips />}></Route>
            <Route path="/tips/safety" element={<SafetyTips />}></Route>
            <Route path="/tips/history" element={<HistoryTips />}></Route>

            <Route path="/places/:id" element={<PlaceToGo />}></Route>

            <Route path="*" element={<Error />}></Route>
          </Routes> */}
      {/* </main> */}
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          <Route index element={<Home />}></Route>
          <Route path="tours/:id" element={<SingleTour />}></Route>

          <Route path="tips/visa" element={<VisaTips />}></Route>
          <Route path="tips/transport" element={<TransportTips />}></Route>
          <Route path="tips/weather" element={<WeatherTips />}></Route>
          <Route path="tips/safety" element={<SafetyTips />}></Route>
          <Route path="tips/history" element={<HistoryTips />}></Route>

          <Route path="places/:id" element={<PlaceToGo />}></Route>

          <Route path="*" element={<Error />}></Route>
        </Route>
      </Routes>
      {/* <Footer /> */}
    </BrowserRouter>
  );
};

export default App;
